const FEELINGS = {
    productivity: {
        id: "productivity",
        title: "Productivity",
        description: "How productive were you yesterday?",
        value: 0,
        max: 10,
    },
    wellbeing: {
        id: "wellbeing",
        title: "Wellbeing",
        description: "How is your general sense of wellbeing today?",
        value: 0,
        max: 10,
    },
}

const QUESTIONS = {
    goal: {
        id: "goal",
        title: "Current Goal",
        subtitle:
            "What is the number one goal you are working on, that if you achieved your goal it would positively change everything for you?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Typically filled out and only changed once completed",
    },
    actions: {
        id: "actions",
        title: "Actions",
        subtitle:
            "What actions are you going to take today towards your goal?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    habits_text: {
        id: "habits_text",
        type: "text",
        title: "When you think about the person you want to be",
        subtitle: "What habits do they have?",
        description:
            "Habits are actions that you take consistently. \nMoving through 4 phases of growth \n\nUNCONSCIOUS INCOMPETENCE. We don't know that we don't know. ...\nCONSCIOUS INCOMPETENCE. We know that we don't know. ... \nCONSCIOUS COMPETENCE. We work at what we don't know. ... \nUNCONSCIOUS COMPETENCE. We don't have to think about knowing it.",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },
    habits_a: {
        id: "habits_a",
        title: "Habit a",
        subtitle:
            "What habits do you wish to nurture and how did you nurture them yesterday through daily actions?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },
    habits_b: {
        id: "habits_b",
        title: "Habit b",
        subtitle:
            "What habits would you like to let go of? ie: those that do not serve your potential. What did you do yesterday that reinforced a negative habit and what are you going to choose differently today?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    contractions: {
        id: "contractions",
        title: "Contractions",
        subtitle:
            "As you go about your day, become aware of your contractions and list those you recall from the previous day.",
        description:
            "Often that which is holding us back is unconscious to us. When we contract during the day often this is pointing to a wound (if you are human, you have them) inside that if it were healed you would have access to more of your potential. These wounds create limitations. As you go about your day, become aware of your contractions and list those you recall from the previous day. Contractions show up as a sudden rush of negative emotion or where your world gets small or where a thought or pattern of thinking is negatively triggered and takes over.",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    beliefs: {
        id: "beliefs",
        title: "Beliefs",
        subtitle:
            "To be the person you want to be, what do you need to believe about yourself? Be specific",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    grateful: {
        id: "grateful",
        title: "Gratitude",
        subtitle: "What are 3 things you're grateful for?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    forgive: {
        id: "forgive",
        title: "Forgiveness",
        subtitle:
            "What do you need to forgive yourself for? Who else do you need to forgive?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    help: {
        id: "help",
        title: "Help Needed",
        subtitle: "What do you need help with?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    win: {
        id: "win",
        title: "Biggest Win",
        subtitle: "What was your biggest win yesterday?",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "Ideally Daily",
    },

    comments: {
        id: "comments",
        title: "Comments",
        subtitle:
            "Any additional information/requests/comments for your iAMconnected coach.",
        description: "",
        value: "",
        sanitised_value: "",
        placeholder: "As needed",
    },
}

export {FEELINGS, QUESTIONS}
